<template>
  <!-- Apollo watched Graphql query -->
  <ApolloQuery
    :query="require('@/graphql/JobPost.gql')"
    :variables="{ id: $route.params.id }"
  >
    <template slot-scope="{ result: { loading, error, data } }">
      <!-- Loading -->
      <div v-if="loading" class="loading apollo">Loading...</div>
      <!-- Error -->
      <div v-else-if="error" class="error apollo">An error occured</div>

      <!-- Result -->
      <div v-else-if="data" class="result apollo">
        <v-container>
          <CandidateReview :jobPost="data.jobPost" />
        </v-container>
      </div>

      <!-- No result -->
      <div v-else class="no-result apollo"></div>
    </template>
  </ApolloQuery>
</template>

<script>
// @ is an alias to /src
import CandidateReview from '@/components/CandidateReview/index';
//import ApplicantsComplete from '@/components/CandidateReview/ApplicantsComplete';

export default {
  name: 'CandidateReviewView',
  data() {
    return {
      jobPost: [],
    };
  },
  components: {
    CandidateReview,
    //ApplicantsComplete,
  },
};
</script>
